<template>
  <link rel="stylesheet" 
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" 
        integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" 
        crossorigin="anonymous"
  >

  <b-navbar toggleable="lg" type="light" variant="light" fixed="top">
    <b-navbar-brand href="/" to="/">M-Direct</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ms-auto">

        <b-nav-item href="/login" to="/login" variant="light" type="light">{{ $t('logInNavBarGuest') }}</b-nav-item>

        <b-dropdown right variant="light" type="light">
          <template #button-content>
            <i class="fa fa-globe"></i> {{ $t('langNavBarGuest') }}
          </template>
          <b-dropdown-item @click="switchLangRu">{{ $t('langRuDropNavBarGuest') }}</b-dropdown-item>
          <b-dropdown-item @click="switchLangBe">{{ $t('langBeDropNavBarGuest') }}</b-dropdown-item>
          <b-dropdown-item @click="switchLangKk">{{ $t('langKkDropNavBarGuest') }}</b-dropdown-item>
          <b-dropdown-item @click="switchLangEn">{{ $t('langEnDropNavBarGuest') }}</b-dropdown-item>
        </b-dropdown>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

  <div id="app">
    <router-view/>
  </div>

</template>

<script>
  export default {
    name: 'App'
  }
</script>

<script setup>
  import { useI18n } from 'vue-i18n';

  const { locale } = useI18n({useScope: 'global'});

  const switchLangRu = () => {
    locale.value = 'ru';
    localStorage.setItem('lang', locale.value);
  }
  const switchLangBe = () => {
    locale.value = 'be';
    localStorage.setItem('lang', locale.value);
  }
  const switchLangKk = () => {
    locale.value = 'kk';
    localStorage.setItem('lang', locale.value);
  }
  const switchLangEn = () => {
    locale.value = 'en';
    localStorage.setItem('lang', locale.value);
  }
</script>

<style>
  #app {
    margin-top: 90px;
  }
</style>